<template>
  <div id="app">
    <div class="page">
      <header class="header">
          <div class="grid-container">
              <div class="grid-x grid-padding-x">
                  <div class="small-12 cell text-center">
                      <a href="./index.html">
                          <img src="./assets/logo.svg" class="logo" width="350" height="64" alt="Fidelidade Auto Easy">
                      </a>
                  </div>
              </div>
          </div>
      </header>
       
      <main id="main">
        <section class="heroshot position-relative">
          <div class="img-dog">
            <img src="./assets/dog.svg" width="220" height="280" alt="logo">
            <div class="img-dog__text">
              SEGURO<br>AUTOMÓVEL
            </div>
          </div>
          <div class="grid-container full-height">
            <div class="grid-x grid-padding-x full-height">
              <div class="small-12 large-7 cell full-height position-relative">
                <div class="heroshot__content">
                  <h1 class="heroshot__title">FIDELIDADE AUTO EASY</h1>
                  <h2 class="heroshot__subtitle">FAZER o seguro obrigatório TOTALMENTE ONLINE é <span>Easy</span></h2>
                </div>
              </div>
              <div class="small-12 large-5 cell full-height">
                <lead-store-component></lead-store-component>
              </div>
            </div>
          </div>
        </section>
        <section class="intro">
          <div class="grid-container">
            <div class="grid-x grid-padding-x align-center">
              <div class="small-11 large-10 cell text-center">
                <!-- <div class="boxes">
                  <div class="box">
                  <img src="./assets/icon-mobile.svg" width="45" alt="Totalmente online">
                  <h3 class="box__title">TOTALMENTE<br> ONLINE</h3>
                </div>
                <div class="box">
                  <img src="./assets/icon-money.svg" width="70" alt="Facilidade de Pagamento">
                  <h3 class="box__title">FACILIDADE DE PAGAMENTO</h3>
                </div>
                <div class="box">
                  <img src="./assets/icon-street.svg" width="70" alt="Assistência em viagem">
                  <h3 class="box__title">ASSISTÊNCIA EM VIAGEM</h3>
                </div>
                <div class="box">
                  <img src="./assets/icon-shield.svg" width="50" alt="Protecção Reforçada">
                  <h3 class="box__title">PROTECÇÃO REFORÇADA</h3>
                </div>
                </div> -->
                <div class="boxes">
                  <vue-slick-carousel v-bind="settings">
                    <div class="box">
                      <img src="./assets/icon-mobile.svg" width="45" height="71" alt="Totalmente online">
                      <h3 class="box__title">TOTALMENTE<br> ONLINE</h3>
                    </div>
                    <div class="box">
                      <img src="./assets/icon-money.svg" width="70" height="63" alt="Facilidade de Pagamento">
                      <h3 class="box__title">FACILIDADE DE PAGAMENTO</h3>
                    </div>
                    <div class="box">
                      <img src="./assets/icon-street.svg" width="70" height="67" alt="Assistência em viagem">
                      <h3 class="box__title">ASSISTÊNCIA EM VIAGEM</h3>
                    </div>
                    <div class="box">
                      <img src="./assets/icon-shield.svg" width="50" height="65" alt="Protecção Reforçada">
                      <h3 class="box__title">PROTECÇÃO REFORÇADA</h3>
                    </div>
                  </vue-slick-carousel>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-container">
            <div class="grid-x grid-padding-x align-center">
              <div class="small-11 large-8 cell text-center">
                <h2 class="intro__title intro__title--primary">FAÇA UMA SIMULAÇÃO ONLINE E SAIBA JÁ QUANTO VAI PAGAR PELO SEU SEGURO AUTO.</h2>
                <h3 class="intro__title">ADESÃO TOTALMENTE ONLINE.</h3>
                <p class="intro__text">A Fidelidade criou um simulador que lhe permite saber o valor do seu Seguro Auto e avançar para a contratação de imediato.</p>
                <a :href="link_one" id="btn-simule-a" target="_blank" class="btn btn--cta">Simule já</a>
              </div>
            </div>
          </div>
        </section>
        <section class="cta">
          <div class="grid-container">
            <div class="grid-x grid-padding-x align-center">
              <div class="small-11 medium-10 large-10 cell text-center">
                <p>O SEU SEGURO, A QUALQUER HORA E EM QUALQUER LUGAR. É <span>EASY!</span></p>
              </div>
            </div>
          </div>
        </section>
        <section class="info">
          <div class="grid-container info__row">
            <div class="grid-x grid-padding-x align-center align-middle">
              <div class="small-12 medium-6 large-5 cell text-center large-order-1">
                <img src="./assets/img-intro1.jpg" srcset="./assets/img-intro1@2x.jpg 2x" width="734" height="397" class="info__img" alt="Totalmente online e facilidade de pagamento">
              </div>
              <div class="small-11 medium-6 cell">
                <div class="info__item">
                  <div class="info__title">TOTALMENTE ONLINE</div>
                  <div class="info__text">Sabia que pode contratar o seu Seguro Auto Easy aqui e agora?</div>
                </div>
                <div class="info__item">
                  <div class="info__title">FACILIDADE DE PAGAMENTO</div>
                  <div class="info__text">Escolha a duração do seu seguro e pague unicamente pelo período escolhido.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-container info__row">
            <div class="grid-x grid-padding-x align-center align-middle">
              <div class="small-12 medium-6 large-5 cell text-center larger-order-1">
                <img src="./assets/img-intro2.jpg" srcset="./assets/img-intro2@2x.jpg 2x"  width="734" height="397" class="info__img" alt="Totalmente online e facilidade de pagamento">
              </div>
              <div class="small-11 medium-6 cell">
                <div class="info__item">
                  <div class="info__title">ASSISTÊNCIA EM VIAGEM</div>
                  <div class="info__text">Caso deseje, adicione em um clique a cobertura de Assistência em Viagem ao seu contrato.</div>
                </div>
                <div class="info__item">
                  <div class="info__title">PROTECÇÃO REFORÇADA</div>
                  <div class="info__text">Beneficie do dobro do capital seguro estipulado por lei, sem qualquer custo adicional. *</div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-container info__row">
            <div class="grid-x grid-padding-x align-center">
              <div class="small-11 large-8 cell text-center">
                <a :href="link_one" id="btn-simule-b" target="_blank" class="btn btn--cta">Simule já</a>
              </div>
            </div>
          </div>
           <div class="grid-container info__row">
            <div class="grid-x grid-padding-x align-center">
              <div class="small-11 medium-12 cell">
                <p class="warning">*O dobro do capital seguro aplica-se apenas a motociclos e veículos ligeiros.</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <footer class="footer">
        <div class="footer__bottom">
          <div class="grid-container">
            <div class="grid-x grid-padding-x">
              <div class="small-12 medium-6 cell">
                <div class="logo-link">
                  <a href="https://ﬁdelidade.co.ao" target="_blank" class="site-link">fidelidade.co.ao</a>
                  <ul class="socials">
                    <li class="socials__item">
                      <a href="https://instagram.com/segurosfidelidadeangola" target="_blank" class="social__btn">
                        <img src="./assets/icon-instagram.svg" width="30" height="30" class="instagram_icon">
                      </a>
                    </li>
                    <li class="socials__item">
                      <a href="https://www.facebook.com/FidelidadeSeguros.Angola/" target="_blank" class="social__btn">
                        <img src="./assets/icon-facebook.svg" width="30" height="30" class="facebook_icon">
                      </a>
                    </li>
                    <li class="socials__item">
                      <a href="https://youtube.com/c/FidelidadeAngolaSeguros" target="_blank" class="social__btn">
                        <img src="./assets/icon-youtube.svg" width="30" height="30" class="youtube_icon">
                      </a>
                    </li>
                    <li class="socials__item">
                      <a href="https://www.linkedin.com/company/segurosfidelidadeangola" target="_blank" class="social__btn">
                        <img src="./assets/icon-linkedin.svg" width="30" height="30" class="linkedin_icon">
                      </a>
                    </li>
                    <li class="socials__item">
                      <a href="https://www.tiktok.com/@fidelidade.angola" target="_blank" class="social__btn">
                        <img src="./assets/icon-tiktok.svg" width="30" height="30" class="linkedin_icon">
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-container text-center">
            <div class="grid-x grid-padding-x">
              <div class="small-12 cell">
                <p class="footer__text">
                  Esta informação não dispensa a consulta da informação pré-contrato e contratual legalmente exigida.<br><br>
                  <strong>FIDELIDADE ANGOLA</strong> - Companhia de Seguros, S.A.<br>
                  Sede: Condomínio Cidade Financeira, Via S8, Edifício 10 - Piso 3. Talatona - Luanda - Angola. Matriculada na Conservatória do Registo Comercial de Luanda sob o n.º 1.234-09 - NIF 5417061590. Capital Social: 3.034.080.000,00 AOA. Tel. +244 923 167 167 - info@ﬁdelidade.co.ao
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div class="fixed-bar">
        <div class="grid-container">
            <div class="grid-x grid-padding-x align-center">
                <div class="small-12 cell">
                    <div class="grid-x grid-padding-x align-middle">
                        <div class="small-12 medium-6 large-5 large-offset-1 cell">
                            <h2 class="fixed-bar__text text-uppercase"><strong>Simule o seu seguro Auto easy.</strong><br><span>Ou fale connosco.</span> </h2>
                        </div>
                        <div class="small-12 medium-6 large-5 large-offset-1 cell text-right">
                            <div class="flex-container align-justify btn-container text-center">
                              <a :href="link_one" id="btn-simule-c" class="btn btn--white" target="_blank">Simular</a>
                              <a href="#form" class="btn btn--white" data-open="contactModal" id="btnLSOpenFhome" aria-controls="contactModal" aria-haspopup="true" tabindex="0">Quero ser contactado</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
import LeadStoreComponent from './components/LeadStore/LeadStoreComponent.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

function getParameterByName (name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  var results = regex.exec(location.search)
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export default {
  name: 'App',
  components: {
    LeadStoreComponent,
    VueSlickCarousel
  },
  data() {
    return {
      utm_campaign: null,
      utm_source: null,
      utm_medium: null,
      utm_content: null,
      utm_term: null,
      initialUrl: 'https://www.fidelidade.co.ao/ao/particulares/auto/auto/Paginas/autoeasy.aspx?utm_source=lp&utm_medium=lp-auto-easy&utm_term=&utm_content=textlink_simule_ja&utm_campaign=autoeasy',
      settings: {
        "dots": true,
        "arrows": false,
        "infinite": true,
        "speed": 500,
        "slidesToShow": 4,
        "slidesToScroll": 4,
        "focusOnSelect": true,
        "touchThreshold": 5,
        
        "responsive": [
          {
            breakpoint: 11600,
            settings: "unslick"
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  },
  methods: {
    generateURL () {
      var baseURL = 'https://www.fidelidade.co.ao/ao/particulares/auto/auto/Paginas/autoeasy.aspx' + '?utm_campaign=' + this.utm_campaign
      if (this.utm_source) {
        baseURL = baseURL + '&utm_source=' + this.utm_source
      }
      if (this.utm_medium) {
        baseURL = baseURL + '&utm_medium=' + this.utm_medium
      }
      if (this.utm_content) {
        baseURL = baseURL + '&utm_content=' + this.utm_content
      }
      if (this.utm_term) {
        baseURL = baseURL + '&utm_term=' + this.utm_term
      }
      return baseURL
    }
  },
  created () {
    this.utm_campaign = getParameterByName('utm_campaign')
    this.utm_source = getParameterByName('utm_source')
    this.utm_medium = getParameterByName('utm_medium')
    this.utm_content = getParameterByName('utm_content')
    this.utm_term = getParameterByName('utm_term')
    if (this.utm_campaign) {
      this.link_one = this.generateURL()
    } else {
      this.link_one = this.initialUrl
    }
  }
}
</script>

<style lang="scss">
  @import "./styles/app.scss";
  @import "./components/LeadStore/style/leadstore.scss";
</style>